import { useThemeStore } from "@stores/theme.store";
import moment from "moment-timezone";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
moment.locale("id");
export const ViolationDetailPage = () => {
  const { state } = useLocation();
  const { setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setAppBar({ title: "Detail Pelanggaran", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Detail Pelanggaran",
    });
  }, [setHeader, setAppBar]);

  return (
    <>
      <div className="tw-px-4 tw-pb-20">
        <div className="tw-bg-other-100 tw-rounded-lg card-body">
          <div className="tw-text-primary-hg tw-text-xs">Tanggal</div>
          <div className="tw-mb-3">
            {moment(state.tanggal ?? Date.now()).format("dddd, DD MMMM YYYY")}
          </div>

          <div className="tw-text-primary-hg tw-text-xs">Pelanggaran</div>
          <div className="tw-mb-3">{state.pelanggaran ?? "-"}</div>

          <div className="tw-text-primary-hg tw-text-xs">Kategori</div>
          <div className="tw-mb-3">{state.kategori ?? "-"}</div>

          <div className="tw-text-primary-hg tw-text-xs">Tindakan</div>
          <div className="tw-mb-3">{state.tindakan ?? "-"}</div>

          <div className="tw-text-primary-hg tw-text-xs">Poin</div>
          <div className="tw-mb-3">{state.poin ?? "-"}</div>

          <div className="tw-text-primary-hg tw-text-xs">Catatan</div>
          <div className="tw-mb-3">{state.catatan ?? "-"}</div>

          <div className="tw-text-primary-hg tw-text-xs">Pelapor</div>
          <div className="tw-mb-3">---</div>
        </div>
      </div>
    </>
  );
};
